import { getBlock } from "../service/getBlock";

export const getBuyersAtApi = async (
        branchsId: string, 
        debouncedClientName: string,
        setResult:(value: any) => void
) => {
    const { block } = await getBlock("/buyer/list", {
        branchsId: branchsId,
        search: debouncedClientName
    });
    
    setResult(block.Buyer)
}